import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { EnhancementService } from 'src/app/services/enhancements-service';
import { FilterService } from 'src/app/services/filter.service';

@Component({
  selector: 'app-bullet-chart-card',
  templateUrl: './bullet-chart-card.component.html',
  styleUrls: ['./bullet-chart-card.component.scss']
})
export class BulletChartCardComponent implements OnInit, OnDestroy {
  static key = 100607;

  @Input('item') item: any
  @Input('pageKey') pageKey: any
  heading: any;
  @Output('onSizeChange') onSizeChange = new EventEmitter<any>()
  @ViewChild('bulletChartDiv', { static: true }) bulletChartDiv!: ElementRef
  config: any
  data: any
  chartData:any
  isDataLoaded = false
  totalData: any
  reqSubcription: Subscription[] = []
  error_name:any;

  constructor(
    private filterService: FilterService, private apiService: ApiService, private httpClient: HttpClient,private enhancementService:EnhancementService
  ) {
    this.reqSubcription.push(this.filterService.filterQuery.subscribe((query: any) => {
      this.loadApiData()
    })
    )
  }
  ngOnInit(): void {
    this.item;

    const observer = new ResizeObserver((e: any) => {
      this.onSizeChange.emit(e[0].contentRect.height);
    });
    observer.observe(this.bulletChartDiv.nativeElement);
    this.loadlineConfig();
  }

  loadlineConfig() {
    this.heading = this.item.config["report_heading"];
  }

  loadApiData(reportType?: string) {
    const api = this.item.config["list_of_api"] || {};
    const endPoint = this.item.config?.["list_of_api_endpoint"] || '';
    const baseUrl = `${this.apiService.apiBaseUrl}/${endPoint || this.apiService.executionUrl}`;

    if (!this.filterService.isEmptyObject(this.filterService.baseQuery)) {
      // prepare common query parameters
      const getQuery = (apiKey: string) => {
        const query = {
          ...this.filterService.baseQuery,
          api_key: apiKey,
          report_typ: this.filterService.report_type,
          table_nm_version: this.enhancementService.currentQuarterFlag ? 'curr' : 'hist',
          module_key: this.apiService.getModuleKey(),
        };
        return query;
      };

      // Main API call
      
      // Child API (if bullet table)
      if (this.item.config["chart_type"] === 'bullettable') {
        this.makeApiCall(baseUrl, getQuery('100197'), 'totalData');
        this.makeApiCall(baseUrl, getQuery('100201'), 'chartData');
        this.makeApiCall(baseUrl, getQuery(api), 'data');
      }else{
        this.makeApiCall(baseUrl, getQuery(api), 'chartData');

      }

    }
  }

  /** Generic API caller */
  private makeApiCall(url: string, payload: any, assignTo: 'data' | 'totalData' | string) {
    const sub = this.httpClient.post(url, payload).subscribe({
      next: (res: any) => {
        this.isDataLoaded = true;
        (this as any)[assignTo] = res ?? [];
        
        let find_filter_key:any = 'source_nm';
        let flag_name = 'decomm_flg';
        this.error_name = this.filterService.getDecommLabel(res, payload, find_filter_key, flag_name);
      },
      error: (err: any) => {
        this.isDataLoaded = true;
        (this as any)[assignTo] = [];
        this.error_name = err?.error?.error?.message || err?.error?.message || err?.message || '';
        // console.error('API Error:', err);
      },
    });
    this.reqSubcription.push(sub);
  }

  ngOnDestroy(): void {
    this.reqSubcription.forEach((res) => res.unsubscribe());
  }
}



